import React, { createContext, useContext, useEffect, useState } from "react";

export interface IAddToPackageContext {
    addedIds: number[];
    addIds: (ids: number[]) => void;
    removeIds: (ids: number[]) => void;
}

const AddToPackageContext = createContext<IAddToPackageContext | undefined>(undefined);
const EMPTY_ADDED_IDS: number[] = [];

export const AddToPackageProvider: React.FC<{ children?: React.ReactNode; initialAddedIds?: number[]; }> = ({ children, initialAddedIds = EMPTY_ADDED_IDS }) => {
    const [addedIds, setAddedIds] = useState<number[]>([]);

    const addIds = (ids: number[]) => {
        setAddedIds(prev =>
            Array.from(new Set([...prev, ...ids]))
        );
    };

    useEffect(() => {
        setAddedIds(initialAddedIds);
    }, [initialAddedIds]);

    const removeIds = (ids: number[]) => {
        const removed = new Set(ids);
        setAddedIds(previous =>
            previous.filter(id => !removed.has(id))
        );
    };

    return (
        <AddToPackageContext.Provider value={{ addedIds, addIds, removeIds }}>
            {children}
        </AddToPackageContext.Provider>
    );
};

export const useAddToPackageContext = () => useContext(AddToPackageContext);
